import { render, staticRenderFns } from "./StudentList.vue?vue&type=template&id=4a70de5f&scoped=true"
import script from "./StudentList.vue?vue&type=script&lang=js"
export * from "./StudentList.vue?vue&type=script&lang=js"
import style0 from "./StudentList.vue?vue&type=style&index=0&id=4a70de5f&prod&lang=css"
import style1 from "./StudentList.vue?vue&type=style&index=1&id=4a70de5f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a70de5f",
  null
  
)

export default component.exports